/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsInfinity: {
  name: 'infinity';
  data: string;
} = {
  name: 'infinity',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 5.5a2.5 2.5 0 0 0 0 5c1.693 0 2.554-1.232 3.584-2.777l.048-.072C8.592 6.21 9.731 4.5 12 4.5a3.5 3.5 0 1 1-2.333 6.109.5.5 0 0 1 .667-.745A2.5 2.5 0 1 0 12 5.5c-1.693 0-2.554 1.232-3.584 2.777l-.048.072C7.408 9.79 6.269 11.5 4 11.5a3.5 3.5 0 1 1 2.333-6.109.5.5 0 1 1-.666.745A2.489 2.489 0 0 0 4 5.5Z" fill="currentColor"/></svg>`,
};
